import { showLoading } from "./loading";
import { subscribeToCalfMortalityPrediction } from "./calf_mortality_prediction";
import { subscribeToWeanWeightPrediction } from "./wean_weight_prediction";
import consumer from "./channels/consumer"

const weanWeightForm = document.getElementById("excel-submission-form-ww");
const calfMortalityForm = document.getElementById("excel-submission-form-cm");
const submissionForm = document.getElementById("excel-submission-form");

let submissionChannel;

if (weanWeightForm) {
  weanWeightForm.addEventListener("submit", handleFormSubmission);
}

if (calfMortalityForm) {
  calfMortalityForm.addEventListener("submit", handleFormSubmission);
}

if (submissionForm) {
  submissionForm.addEventListener("submit", handleFormSubmission);
}

function handleFormSubmission(event) {
  const form = event.target;
  const formData = new FormData(form);

  fetch(form.action, {
    method: form.method,
    body: formData,
    headers: {
      "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content,
    },
    credentials: "same-origin",
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.status === "created") {
        // Show loading gif until job is finished
        if (form.id === 'excel-submission-form-ww') {
          showLoading();
          subscribeToWeanWeightPrediction(data.uuid);
        } else if (form.id == 'excel-submission-form-cm') {
          showLoading();
          subscribeToCalfMortalityPrediction(data.uuid);
        }
        else {
          showLoading();
          subscribeToSubmission(data.uuid);
        }
      } else {
        // Handle errors
      }
    });
  event.preventDefault();
}

function displayNotice(jsonData) {
  const data = JSON.parse(jsonData);
  console.log(data.messages);
  // get the div where you want to display the messages
  const messagesDiv = document.getElementById('submission-messages');

  if(data && data.messages){
    const messages = data.messages.join('\n');
    alert(`Submission job has completed. Messages: \n${messages}`);
    // update the div with the messages
    messagesDiv.innerText += `Submission job has completed. Messages: \n${messages}`;
  } else {
    alert("Submission job has failed unexpectedly.");
    messagesDiv.innerText += "Submission job has failed unexpectedly.";
  }
}

function subscribeToSubmission(uuid) {
  submissionChannel = consumer.subscriptions.create(
    { channel: "SubmissionChannel", uuid: uuid },
    {
      received(data) {
        document.body.querySelector('img').remove();
        console.log('Received from Submission Job');
        displayNotice(data);
      },
    }
  );
}
